import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const mustChangePasswordGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn() && auth.mustChangePassword()) {
    router.navigate(['/change-password']);
    return false;
  }
  return true;
};
